import { BuildType } from 'mbs-ui-shared@models/BuildType.enum';
import { AgentType, OsType } from 'mbs-ui-shared@models/Computer';
import { PermissionsEnum } from 'mbs-ui-shared@models/PermissionsEnum';
import { BuildOsType, BuildVersionType } from 'mbs-ui-shared@models/build';

export type ForceUpdateAgentSection = {
  agentType: AgentType;
  permission: PermissionsEnum;
  iconClass: string;
  productKey: string;
  versionTypes: BuildVersionType[];
};

export const forceUpdateAgentSections: ForceUpdateAgentSection[] = [
  {
    agentType: AgentType.Backup,
    permission: PermissionsEnum.Backup,
    iconClass: 'mbs-agent_backup',
    productKey: 'shared:products.backup',
    versionTypes: [BuildVersionType.Public, BuildVersionType.Sandbox, BuildVersionType.Beta]
  },
  {
    agentType: AgentType.RMM,
    permission: PermissionsEnum.Rmm,
    iconClass: 'mbs-agent_rmm',
    productKey: 'shared:products.rmm',
    versionTypes: [BuildVersionType.Public, BuildVersionType.Sandbox]
  },
  {
    agentType: AgentType.RA,
    permission: PermissionsEnum.ShowRemoteConnection,
    iconClass: 'mbs-agent_connect',
    productKey: 'shared:products.remote_desktop',
    versionTypes: [BuildVersionType.Public]
  }
];

export const forceUpdateOsKeys: Partial<Record<OsType, string>> = {
  [OsType.windows]: 'shared:forceUpdate.os.windows',
  [OsType.apple]: 'shared:forceUpdate.os.macos',
  [OsType.linux]: 'shared:forceUpdate.os.linux'
};

export const forceUpdateBuildOsKeys: Record<BuildOsType, string> = {
  [BuildOsType.Windows]: forceUpdateOsKeys[OsType.windows],
  [BuildOsType.Linux]: forceUpdateOsKeys[OsType.linux],
  [BuildOsType.Mac]: forceUpdateOsKeys[OsType.apple],
  [BuildOsType.MacArm]: forceUpdateOsKeys[OsType.apple]
};

export const forceUpdateBuildTypeKeys: Partial<Record<BuildType, string>> = {
  [BuildType.CommonWindowsBuild]: forceUpdateOsKeys[OsType.windows],
  [BuildType.VMware]: 'shared:forceUpdate.os.windowsVm',
  [BuildType.LinuxRedHat6]: 'shared:forceUpdate.os.linuxRpm',
  [BuildType.LinuxUbuntu14]: 'shared:forceUpdate.os.linuxDeb',
  [BuildType.LinuxMac]: 'shared:forceUpdate.os.macosIntel',
  [BuildType.MacArm]: 'shared:forceUpdate.os.macosArm',
  [BuildType.RMMAgentExe]: forceUpdateOsKeys[OsType.windows],
  [BuildType.RMMAgentMsi]: 'shared:forceUpdate.os.windowsMsi',
  [BuildType.RMMAgentMac]: forceUpdateOsKeys[OsType.apple],
  [BuildType.RMMAgentLinuxDeb]: 'shared:forceUpdate.os.linuxDeb',
  [BuildType.RMMAgentLinuxRpm]: 'shared:forceUpdate.os.linuxRpm',
  [BuildType.CBLRA]: forceUpdateOsKeys[OsType.windows],
  [BuildType.MacRA]: forceUpdateOsKeys[OsType.apple]
};

export const getForceUpdateBuildOsKey = (buildType: BuildType, os: BuildOsType): string =>
  forceUpdateBuildTypeKeys[buildType] ?? forceUpdateBuildOsKeys[os];
